import { Button } from '@/components/ui/button';
import { AGENT_ACCESS_COPY } from './agent-access-copy';

type LoadFailedProps = { text?: string; onRetry: () => void };

/** Something that failed to load says so, with a retry, rather than looking empty. */
export const LoadFailed = ({ text = AGENT_ACCESS_COPY.loadFailed, onRetry }: LoadFailedProps) => (
  <div className="flex items-center gap-2">
    <p className="supporting text-danger m-0">{text}</p>
    <Button
      type="button"
      variant="ghost"
      size="sm"
      onClick={onRetry}
      className="micro-label text-dim hover:text-foreground hover:bg-hover h-7 rounded-lg px-2"
    >
      {AGENT_ACCESS_COPY.retry}
    </Button>
  </div>
);
